import { SelectionModel } from '@angular/cdk/collections';
import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { NTHFlag } from 'src/app/shared/constants/flag';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { BcLineModel } from 'src/app/shared/models/societe-linked/bc/bc-line.model';

@Component({
  selector: 'app-fixed-bc-line-list-read',
  templateUrl: './fixed-bc-line-list-read.component.html',
  styleUrls: ['./fixed-bc-line-list-read.component.scss']
})
export class FixedBcLineListReadComponent implements OnChanges {
  @ViewChild('table', { static: true }) table;
  @Input() form: UntypedFormGroup;
  bcLine: BcLineModel = new BcLineModel();
  showDelay = new UntypedFormControl(0);
  hideDelay = new UntypedFormControl(0);
  ValidationStatus: string[] = ['A Valider', 'Validation 1', 'Validation 2', 'Validation 3' , 'Validation 4'];
  displayedColumnsBC: string[] = ['annule', 'libelle', 'qte', 'qteLiv', 'dLivraison', 'pu', 'tva', 'naCode', 'cg', 'ca1', 'ca2', 'complement', 'equipement', 'codeAe', 'mntHt', 'p', 'd'];
  matDataSourceBCLigne: MatTableDataSource<AbstractControl> = new MatTableDataSource<AbstractControl>();
  selection = new SelectionModel<BcLineModel>(true, []);
  bcLineFormArray: UntypedFormArray;
  public FlagEnum: NTHFlag;
  constructor() {
  }
 
  ngOnChanges(changes: SimpleChanges): void {
    if (this.form) {
      this.bcLineFormArray = this.form.controls['bcLines'] as UntypedFormArray;
      this.reload();
    }
  }

  reload(): void {
    if (this.bcLineFormArray) {
      this.matDataSourceBCLigne = new MatTableDataSource(this.bcLineFormArray.controls);
    }
  }
}

